import { render, staticRenderFns } from "./VirtualBetslip.vue?vue&type=template&id=11690a84"
import script from "./VirtualBetslip.vue?vue&type=script&lang=js"
export * from "./VirtualBetslip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports